// extracted by mini-css-extract-plugin
export var configurationSection = "_z3-0";